import { PropTypes } from "prop-types";
import { Button, IconButton, Alert, AlertTitle, Link } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Country, State } from "country-state-city";
import { branches } from "../../constants/enums";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import { LargeAvatar } from "../../styles/materialUi/avatar";
import "./alumProfile.scss";

const propTypes = {
  cohort: PropTypes.objectOf(PropTypes.any).isRequired,
  alumniProfile: PropTypes.objectOf(PropTypes.any).isRequired,
  createProfile: PropTypes.bool.isRequired,
  isMyProfilePage: PropTypes.bool.isRequired,
  setIsEditMode: PropTypes.func.isRequired,
};

const AlumProfile = ({
  cohort,
  alumniProfile,
  createProfile,
  isMyProfilePage,
  setIsEditMode,
}) => {
  const displayLocation = () => {
    const location = [];
    if (alumniProfile.cityName) location.push(alumniProfile.cityName);
    if (alumniProfile.stateCode) {
      location.push(
        State.getStateByCodeAndCountry(
          alumniProfile.stateCode,
          alumniProfile.countryCode
        ).name
      );
    }
    if (alumniProfile.countryCode) {
      location.push(Country.getCountryByCode(alumniProfile.countryCode).name);
    }
    if (location.length > 0) {
      return <div className="location">{location.join(", ")}</div>;
    }
    return null;
  };

  return (
    <>
      {createProfile ? (
        <div className="create-profile-btn-div">
          <Button
            color="secondary"
            variant="contained"
            onClick={() => setIsEditMode(true)}
          >
            Create your profile
          </Button>
        </div>
      ) : (
        <div className="alum">
          <ProfilePicture
            avatar={LargeAvatar}
            editable={isMyProfilePage}
            profileId={alumniProfile.id}
            objectKey={alumniProfile.profilePictureKey || ""}
            alt={alumniProfile.firstNameDisplay || ""}
          />
          <div className="profile">
            {isMyProfilePage && (
              <div className="edit-icon-div">
                <IconButton
                  aria-label="edit"
                  onClick={() => setIsEditMode(true)}
                  size="large"
                >
                  <EditOutlinedIcon fontSize="large" />
                </IconButton>
              </div>
            )}
            <div className="name">
              {alumniProfile.firstNameDisplay} {alumniProfile.lastNameDisplay}
              {alumniProfile.email && (
                <Link href={`mailto:${alumniProfile.email}`}>
                  <IconButton aria-label="Send Email">
                    <EmailOutlinedIcon />
                  </IconButton>
                </Link>
              )}
            </div>
            <div className="cohort-branch">
              {cohort.name} {cohort.year} &#8226;{" "}
              {branches[alumniProfile.branch]}
              {alumniProfile.isMilitarySpouse ? " (Military Spouse)" : ""}
            </div>
            {displayLocation()}
            {alumniProfile.linkedInUrl && (
              <Link
                href={alumniProfile.linkedInUrl}
                underline="hover"
                target="_blank"
                rel="noopener"
                className="linkedin-link"
              >
                View profile on LinkedIn
              </Link>
            )}
            <div>
              {alumniProfile.isOpenToWork && (
                <div className="check-container">
                  <CheckCircleOutlineRoundedIcon className="check-icon" />
                  <span>Open to Work</span>
                </div>
              )}
              {alumniProfile.isWillingToTravel && (
                <div className="check-container">
                  <CheckCircleOutlineRoundedIcon className="check-icon" />
                  <span>Willing to Travel</span>
                </div>
              )}
            </div>
            <div className="about">
              <div className="section-title">About</div>
              {alumniProfile.about}
            </div>
            <div className="skills">
              <div className="section-title">Skills</div>
              {alumniProfile.skills &&
                alumniProfile.skills.map((skill) => (
                  <p className="skill" key={skill}>
                    {skill}
                  </p>
                ))}
            </div>
            {isMyProfilePage && !alumniProfile.publicProfile && (
              <Alert variant="outlined" severity="info">
                <AlertTitle>Your profile is not public.</AlertTitle>
                Your profile is only visible to admin and the other alumni.
              </Alert>
            )}
          </div>
        </div>
      )}
    </>
  );
};

AlumProfile.propTypes = propTypes;

export default AlumProfile;
